import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { r_burger } from '@fiverr-private/fit/icons';
import { Icon } from '@fiverr-private/fit';

import classes from './HamburgerBtn.module.scss';

export const HamburgerBtn = forwardRef(({
    className,
    hamburgerIcon,
    ...rest
}, ref) => (
    <button ref={ref} className={classNames(classes.btn, className)} {...rest}>
        {hamburgerIcon || <Icon className={classes.icon}>{r_burger}</Icon>}
    </button>
));

HamburgerBtn.displayName = 'HamburgerBtn';

/**
 * @extends {
* Omit<
*  React.ButtonHTMLAttributes<HTMLButtonElement>,
*  | 'children'
* >
* }
*/
HamburgerBtn.propTypes = {
    className: PropTypes.string,
    hamburgerIcon: PropTypes.node
};
